import { CKEditor } from '@ckeditor/ckeditor5-react';
import { updateWhatTheySeek } from '@webapps/business';
import {
  useAuth,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import * as yup from 'yup';

const schema = yup.object().shape({
  whattheyseek: yup.string(),
});

const WhatTheySeekEdit = ({ close, whattheyseek }) => {
  const {
    classes,
    css,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();

  const {
    error,
    isLoading,
    isSuccess,
    mutateAsync: mutateUpdateInfos,
  } = useMutation(updateWhatTheySeek);

  const { addToast } = useToast();

  useEffect(() => {
    if (error) {
      addToast({
        status: 'error',
        message: 'Erreur pour modifier la section "Ce qu\'ils cherchent"',
      });
    }
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Section "Ce qu\'ils cherchent" modifiée avec succès',
      });
      close();
    }
  }, [error, isSuccess]);

  const formik = useFormik({
    initialValues: {
      whattheyseek,
    },
    validationSchema: schema,
    onSubmit: async (values) => {
      await mutateUpdateInfos({
        data: values?.whattheyseek,
        id: idUser,
      });
    },
  });

  const [count, setCount] = React.useState(0);
  const [textarea, setTextarea] = React.useState(formik.values.whattheyseek);

  const [countAspect, setCountAspect] = React.useState('countAspect');
  const countAspectRef = React.useRef();
  countAspectRef.current = countAspect;

  const handleSubmit = () => {
    if (!textarea) {
      formik.values.whattheyseek = ' ';
    } else {
      formik.values.whattheyseek = textarea;
    }
    formik.handleSubmit();
  };

  useEffect(() => {
    if (whattheyseek) {
      setTextarea(whattheyseek);
    }
  }, [whattheyseek]);

  return (
    <>
      <div
        className={classes.editorDiv}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          position: 'relative',
          marginTop: 20,
        }}
      >
        <CKEditor
          config={{
            wordCount: {
              onUpdate: (stats) => {
                setCount(stats.characters);
              },
            },
            toolbar: ['numberedList', 'bulletedList'],
            resize_enabled: false,
          }}
          data={textarea}
          editor={Editor}
          onBlur={handleSubmit}
          onChange={(event, editor) => {
            setTextarea(editor.getData());
            if (count > 280) {
              setCountAspect('countAspectPassed');
            } else {
              setCountAspect('countAspect');
            }
          }}
        />
        <div className={cx(classes[countAspectRef.current], classes.wordCount)}>
          Caractères: {count} / 280
        </div>
      </div>
    </>
  );
};

const styles = () => ({
  editorDiv: {
    color: '#152652',
    '.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar, .ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners':
      {
        border: '1px solid #C0D9FF',
        borderRadius: '8px 8px 0 0',
        backgroundColor: '#F3F7FF',
        borderBottom: 'none',
        paddingLeft: '10px',
        outline: 'red',
      },
    '.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused)': {
      border: '1px solid #C0D9FF',
      borderRadius: '0 0 8px 8px',
      backgroundColor: '#F3F7FF',
      padding: '10px 20px',
      paddingBottom: '40px',
      whiteSpace: 'normal',
      wordBreak: 'break-all',
      overflowWrap: 'break-word',
    },
    '.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable, .ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners':
      {
        borderRadius: '0 0 8px 8px',
        padding: '10px 20px',
        paddingBottom: '40px',
      },
    '.ck.ck-editor': {
      width: '100%',
      overflowY: 'auto',
    },
  },
  wordCount: {
    position: 'absolute',
    bottom: '20px',
    right: '20px',
  },
  countAspect: {
    color: '#5D75A8',
  },
  countAspectPassed: {
    color: 'red',
  },
});

WhatTheySeekEdit.propTypes = {
  whattheyseek: PropTypes.string,
  close: PropTypes.func,
};

export default WhatTheySeekEdit;
